import { useNavigate } from "react-router-dom";
import { Hand, Users, HeartHandshake, ChevronRight, ChevronLeft } from "lucide-react";
import PortalExit from "@/components/PortalExit";

const PALM =
  "https://customer-assets.emergentagent.com/job_f2410923-45b5-41a3-af61-0c43786e0f4d/artifacts/phtrtj13_Screenshot%202026-07-09%20at%209.56.10%E2%80%AFAM.png";

const MODES = [
  { key: "dominant", label: "Your leading hand", desc: "The hand you write with", icon: Hand },
  { key: "both", label: "Both hands", desc: "Left and right, in dialogue", icon: Users },
  { key: "couples", label: "Two of you", desc: "Side by side", icon: HeartHandshake },
];

export default function PortalHome() {
  const navigate = useNavigate();

  return (
    <div className="soma-grain relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-soma-surface px-5 py-12">
      <button
        onClick={() => navigate("/portal", { replace: true })}
        data-testid="portal-back"
        className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-soma-surface2/70 text-soma-muted hover:text-soma-on"
        aria-label="Back"
      >
        <ChevronLeft size={18} />
      </button>
      <PortalExit />

      <div className="mb-8 text-center">
        <div className="mx-auto mb-6 h-32 w-24 overflow-hidden rounded-2xl border border-soma-brand/40 bg-[#EDE4D1] shadow-xl shadow-black/50">
          <img src={PALM} alt="" className="h-full w-full object-cover object-top" />
        </div>
        <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-soma-brand">// the palm portal</p>
        <h1 className="mt-2 font-display text-4xl italic leading-tight text-soma-on md:text-5xl">
          Your palms carry a story.
        </h1>
        <p className="mt-3 max-w-md text-sm text-soma-on2">
          Not a prediction — a pattern. Choose a hand, and let the lines begin.
        </p>
      </div>

      <div className="grid w-full max-w-md grid-cols-1 gap-3">
        {MODES.map((m) => (
          <button
            key={m.key}
            data-testid={`portal-mode-${m.key}`}
            onClick={() => navigate(`/reading/capture?mode=${m.key}&portal=1`)}
            className="group flex items-center gap-4 rounded-2xl border border-soma-border bg-soma-surface2 p-5 text-left transition-colors hover:border-soma-brand"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-soma-brand/15 text-soma-brand">
              <m.icon size={22} />
            </div>
            <div className="flex-1">
              <p className="font-medium text-soma-on">{m.label}</p>
              <p className="text-xs text-soma-muted">{m.desc}</p>
            </div>
            <ChevronRight size={18} className="text-soma-muted transition-transform group-hover:translate-x-1 group-hover:text-soma-brand" />
          </button>
        ))}
      </div>
    </div>
  );
}
